/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [createQRCode↗](https://yapi.fenxianglife.com/project/379/interface/api/41992) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `POST /user/login/mp/createQRCode`
 * @更新时间 `2023-09-26 16:56:17`
 */
export const feimaChatUserLoginMpCreateQrCode = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserLoginMpCreateQrCodeRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatUserLoginMpCreateQrCodeResponse, OT>
  >('/user/login/mp/createQRCode', 'POST', data, options);

/**
 * 接口 [创建Bot关注二维码] 的 **请求函数**
 *
 * @分类 [用户相关]
 * @请求头 `POST /user/login/mp/createBotFollowQRCode`
 */
export const feimaChatUserLoginMpCreateBotFollowQrCode = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserLoginMpCreateBotFollowQrCodeRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatUserLoginMpCreateBotFollowQrCodeResponse,
      OT
    >
  >('/user/login/mp/createBotFollowQRCode', 'POST', data, options);

/**
 * 接口 [queryMpLoginStatus↗](https://yapi.fenxianglife.com/project/379/interface/api/41998) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `POST /user/login/mp/query`
 * @更新时间 `2023-11-01 16:14:47`
 */
export const feimaChatUserLoginMpQuery = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserLoginMpQueryRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUserLoginMpQueryResponse, OT>>(
    '/user/login/mp/query',
    'POST',
    data,
    options
  );

/**
 * 接口 [用户信息↗](https://yapi.fenxianglife.com/project/379/interface/api/42004) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `GET /user/info`
 * @更新时间 `2024-01-22 19:36:37`
 */
export const feimaChatUserInfo = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatUserInfoRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUserInfoResponse, OT>>(
    '/user/info',
    'GET',
    data,
    options
  );

/**
 * 接口 [queryChatQualification↗](https://yapi.fenxianglife.com/project/379/interface/api/42100) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `GET /user/chat/qualification`
 * @更新时间 `2023-09-26 16:56:18`
 */
export const feimaChatUserChatQualification = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatUserChatQualificationRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatUserChatQualificationResponse, OT>
  >('/user/chat/qualification', 'GET', data, options);

/**
 * 接口 [loginByMpAuthorize↗](https://yapi.fenxianglife.com/project/379/interface/api/42154) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `POST /user/login/mp`
 * @更新时间 `2023-09-26 16:56:17`
 */
export const feimaChatUserLoginMp = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserLoginMpRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUserLoginMpResponse, OT>>(
    '/user/login/mp',
    'POST',
    data,
    options
  );

/**
 * 接口 [绑定手机号↗](https://yapi.fenxianglife.com/project/379/interface/api/42220) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `POST /user/bindMobile`
 * @更新时间 `2024-05-06 17:31:23`
 */
export const feimaChatUserBindMobile = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserBindMobileRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUserBindMobileResponse, OT>>(
    '/user/bindMobile',
    'POST',
    data,
    options
  );

/**
 * 接口 [微信修改头像昵称、手机号] 的 **请求函数**
 *
 * @请求头 `POST /user/modify/userInfo`
 * @接口ID 417800202
 */
export const feimaChatUserModifyUserInfo = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: {
    type: number;
    mobile?: string;
    mobileArea?: string;
    smsCode?: string;
    headPic?: string;
    nickname?: string;
  },
  options?: OT
) => request('/user/modify/userInfo', 'POST', data, options);

/**
 * 接口 [getUserName↗](https://yapi.fenxianglife.com/project/379/interface/api/42874) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `GET /user/getUserName`
 * @更新时间 `2023-09-26 16:56:18`
 */
export const feimaChatUserGetUserName = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserGetUserNameRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUserGetUserNameResponse, OT>>(
    '/user/getUserName',
    'GET',
    data,
    options
  );

/**
 * 接口 [checkQualification↗](https://yapi.fenxianglife.com/project/379/interface/api/43054) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `POST /user/chat/qualification/check`
 * @更新时间 `2023-09-26 16:56:18`
 */
export const feimaChatUserChatQualificationCheck = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserChatQualificationCheckRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatUserChatQualificationCheckResponse,
      OT
    >
  >('/user/chat/qualification/check', 'POST', data, options);

/**
 * 接口 [loginByMiniApp↗](https://yapi.fenxianglife.com/project/379/interface/api/44170) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `POST /user/login/miniApp`
 * @更新时间 `2023-09-26 16:56:18`
 */
export const feimaChatUserLoginMiniApp = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserLoginMiniAppRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUserLoginMiniAppResponse, OT>>(
    '/user/login/miniApp',
    'POST',
    data,
    options
  );

/**
 * 接口 [修改用户信息↗](https://yapi.fenxianglife.com/project/379/interface/api/44176) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `POST /user/update`
 * @更新时间 `2023-09-26 16:56:18`
 */
export const feimaChatUserUpdate = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserUpdateRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUserUpdateResponse, OT>>(
    '/user/update',
    'POST',
    data,
    options
  );

/**
 * 接口 [绑定小程序手机号↗](https://yapi.fenxianglife.com/project/379/interface/api/44182) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `POST /user/bindMobileByMiniApp`
 * @更新时间 `2023-09-27 14:40:56`
 */
export const feimaChatUserBindMobileByMiniApp = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserBindMobileByMiniAppRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatUserBindMobileByMiniAppResponse, OT>
  >('/user/bindMobileByMiniApp', 'POST', data, options);

/**
 * 接口 [手机号登录↗](https://yapi.fenxianglife.com/project/379/interface/api/47518) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `POST /user/login/mobile`
 * @更新时间 `2024-04-29 18:07:11`
 */
export const feimaChatUserLoginMobile = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserLoginMobileRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUserLoginMobileResponse, OT>>(
    '/user/login/mobile',
    'POST',
    data,
    options
  );

/**
 * 接口 [随机验证码登录↗](https://yapi.fenxianglife.com/project/379/interface/api/47524) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `POST /user/login/verifyTicket`
 * @更新时间 `2024-01-09 14:57:33`
 */
export const feimaChatUserLoginVerifyTicket = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserLoginVerifyTicketRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatUserLoginVerifyTicketResponse, OT>
  >('/user/login/verifyTicket', 'POST', data, options);

/**
 * 接口 [验证码信息查询↗](https://yapi.fenxianglife.com/project/379/interface/api/47530) 的 **请求函数**
 *
 * @分类 [用户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9885)
 * @请求头 `POST /user/verifyTicketInfo`
 * @更新时间 `2024-02-04 15:07:22`
 */
export const feimaChatUserVerifyTicketInfo = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUserVerifyTicketInfoRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatUserVerifyTicketInfoResponse, OT>
  >('/user/verifyTicketInfo', 'POST', data, options);

/**
 * 创建绑定微信二维码
 *
 * @请求头 `POST /user/login/mp/createBindQRCode`
 */
export const feimaChatUserLoginMpCreateBindQrCode = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: {
    scene?: string;
    showBase64?: boolean;
    userId?: string;
  },
  options?: OT
) => request('/user/login/mp/createBindQRCode', 'POST', data, options);

/**
 * 查询微信绑定状态
 *
 * @请求头 `POST /user/bind/mp/query`
 */
export const feimaChatUserBindMpQuery = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: {
    cpUserId?: string;
    entId?: string;
    sceneId?: string;
  },
  options?: OT
) => request('/user/bind/mp/query', 'POST', data, options);

/**
 * 获取历史记录（对话历史/资讯推送记录/视频生成记录）
 *
 * @请求头 `POST /session/conversation/unifiedList/merged`
 */
export const feimaChatSessionConversationUnifiedList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: {
    size?: number;
    page?: number;
    isLimit?: boolean;
    lastId?: number;
    /** 列表类型：1-对话历史 2-资讯推送记录 3-视频生成记录 */
    type?: number;
    botId?: string;
    /** 排序：1=时间正序，2=时间倒序（默认） */
    sortType?: number;
  },
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatSessionConversationListResponse, OT>
  >('/session/conversation/unifiedList/merged', 'POST', data, options);

/* prettier-ignore-end */
